import { render, staticRenderFns } from "./claim-new.vue?vue&type=template&id=21797dbc&scoped=true&"
import script from "./claim-new.vue?vue&type=script&lang=js&"
export * from "./claim-new.vue?vue&type=script&lang=js&"
import style0 from "./claim-new.vue?vue&type=style&index=0&id=21797dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21797dbc",
  null
  
)

export default component.exports